import type { DBCodeTable } from '@functions/models/DBEnum';
import type { IntCodeTablesData } from '@functions/models/interfaces/intCodeTables';
import type { IntCodeTablesNameData } from '@functions/models/interfaces/intCodeTablesName';



export const useStoreCodeTables = defineStore( 'storeCodeTables', {

    state: () => ( {
        codeTablesName: [] as IntCodeTablesNameData[],
        codeTables: [] as IntCodeTablesData[],
        fetching: false,
        loaded: false,
    } ),

    getters: {
        getCodeTables: state => ( state.codeTables.length > 0 ? state.codeTables : [] ),
        getCodeTablesName: state => ( state.codeTablesName.length > 0 ? state.codeTablesName : [] ),
        // 👉 Getter che filtra per tableName
        getCodeTablesByTableName: ( state ) => ( tableName: string | DBCodeTable ) => {
            if ( !tableName ) return []
            // trova la "tabella" per nome
            const nameRec = state.codeTablesName.find(
                ( n ) => n.tableName?.trim().toLowerCase() === tableName.trim().toLowerCase()
            )
            // se non c'è o non ha id, niente risultati
            const nameId = ( nameRec as any )?.id as string | undefined
            if ( !nameId ) return []
            // filtra i codetables collegati a quell'id
            return state.codeTables.filter( ct => ct.idCodeTablesName === nameId )
        },
        getCodeTablesByTableId: ( state ) => ( tableId: string | DBCodeTable ) => {
            if ( !tableId ) return []
            // trova la "tabella" per id
            /*const idRec = state.codeTables.find( n => n.idCodeTablesName === tableId )
            // se non c'è o non ha id, niente risultati
            const nameId = ( idRec as any )?.id as string | undefined
            if ( !nameId ) return []*/
            // filtra i codetables collegati a quell'id
            return state.codeTables.filter( ct => ct.idCodeTablesName === tableId )
        },
        getCodeTablesById: ( state ) => ( idCodeTable: string | DBCodeTable ) => {
            if ( !idCodeTable ) return {}

            const x = state.codeTables.find( ct => ct.id === idCodeTable )
            return x || {}
        },
        getCodeTablesNamesByTableId: ( state ) => ( tableId: string | DBCodeTable ) => {
            if ( !tableId ) return {}

            // trova la "tabella" per id
            const idRec = state.codeTablesName.find( n => n.id === tableId )
            if ( !idRec?.id ) return {}

            // trova il primo codeTable collegato a quell'id
            const el = state.codeTablesName.find( ct => ct.id === idRec.id )

            // se trovato restituisce l’oggetto, altrimenti {}
            return el || {}
        },
        getCodeTablebyId: ( state ) => ( tableNameId: string | DBCodeTable, idCodeTable: string ) => {
            if ( !idCodeTable || !tableNameId ) return {}
            const x = state.codeTables.find( ct => ct.id === idCodeTable && ct.idCodeTablesName === tableNameId )
            return x || {}
        }
    },
    actions: {
        setCodeTables ( codeTables: IntCodeTablesData[] ) {
            this.codeTables = codeTables
        },
        setCodeTablesName ( codeTablesName: IntCodeTablesNameData[] ) {
            this.codeTablesName = codeTablesName
        },

    },
} )

